module.exports = ".divImg2{\r\n  float: left;\r\n}\r\n\r\n.img2{\r\n    width: 200px;\r\n    margin-right: 5px;\r\n    margin-bottom: 5px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/design/proyecto-d/proyecto-d.component.css
// module id = ./src/app/design/proyecto-d/proyecto-d.component.css
// module chunks = main